import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import HeaderContext from 'remote-com-shared/components/Header/context';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import smoothscroll from 'smoothscroll-polyfill';

import { BenefitsIntroSlice } from './slices/BenefitsIntroSlice';
import { BenefitsTableSlice } from './slices/BenefitsTableSlice';
import { CtaSlice } from './slices/CtaSlice';
import { HeroSlice } from './slices/HeroSlice';
import { VideoEmbedSlice } from './slices/VideoEmbedSlice';

import { FooterOnlyLayout } from '@/layouts/FooterOnly';
import { Header } from '@/src/views/SharedEvents/Header';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const components = {
  benefits_header: HeroSlice,
  video_embed: VideoEmbedSlice,
  benefits_intro: BenefitsIntroSlice,
  benefits_table: BenefitsTableSlice,
  call_to_actions: CtaSlice,
};

export function BenefitsDirectoryPage(document) {
  const headerRef = useRef(null);
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <HeaderContext.Provider value={headerRef}>
      <DocumentHead document={document} noIndex />
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-bossa.css')} />
      </Head>
      <Header ref={headerRef} />
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </HeaderContext.Provider>
  );
}

BenefitsDirectoryPage.Layout = FooterOnlyLayout;
